import ExcelJS from 'exceljs';

const obj = {
    selectStyle(name, value, cell) {
        if (name === "border")
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        else if (name === "color")
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: value }, // Жёлтый цвет
            };
        else if (name === "bold")
            cell.font = {
                bold: true
            };
        else if (name === "wrapText")
            cell.alignment = {
                wrapText: true
            };
    },

    setStyleCell({ name, value, start, end }, worksheet) {
        for (let R = start[0]; R <= end[0]; R++) {
            for (let C = start[1]; C <= end[1]; C++) {
                const cell = worksheet.getRow(R).getCell(C);
                this.selectStyle(name, value, cell);
            }
        }
    },

    getColumnLetter(index) {
        let letter = "";
        while (index > 0) {
            const mod = (index - 1) % 26;
            letter = String.fromCharCode(65 + mod) + letter;
            index = Math.floor((index - 1) / 26);
        }
        return letter;
    },

    mergeCells(start, end, worksheet) {
        const [startRow, startCol] = start;
        const [endRow, endCol] = end;

        const startCell = `${this.getColumnLetter(startCol)}${startRow}`;
        const endCell = `${this.getColumnLetter(endCol)}${endRow}`;
        worksheet.mergeCells(`${startCell}:${endCell}`);
    },

    exportToExcel(data, name) {
        const { text, style, width, merges } = data;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('My Sheet');

        worksheet.columns = width;

        worksheet.addRows(text);

        style.forEach(it => {
            this.setStyleCell(it, worksheet);
        });

        if (merges) {
            merges.forEach(({ start, end }) => {
                this.mergeCells(start, end, worksheet);
            });
        }

        const desiredHeight = 15;

        worksheet.eachRow(function (row, rowNumber) {
            row.height = desiredHeight;
        });

        workbook.xlsx.writeBuffer().then(dataFile => {
            const blob = new Blob([dataFile], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            link.remove();
        });

    },

};

export default obj;
